// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import OneToOneOutlined from '/root/workspace/csida-backstage_x9X2/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/OneToOneOutlined';
import TeamOutlined from '/root/workspace/csida-backstage_x9X2/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined';
export default { OneToOneOutlined, TeamOutlined };
